import {instance} from "@shared/api/axiosInstance";


export const checkRunningGameApi = {

    checkRunningGame() {
        return instance.get<string | null>(`games/check`).then(res => res.data)
    }
}